import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { scrollTo } from 'utils/helpers';

const ScrollToTop = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    scrollTo();
  }, [location.pathname]);

  return children;
};

export default ScrollToTop;
